import { useNavigate, useSearchParams } from "react-router-dom";
import { SupplierCreditNotesListPage as SupplierCreditNotesListPageView } from "@/components/SupplierCreditNotesListPage";

export function SupplierCreditNotesListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const supplierId = searchParams.get("supplierId") ?? undefined;

  return (
    <SupplierCreditNotesListPageView
      defaultSupplierId={supplierId}
      onSupplierFilterChange={(next) => {
        const params = new URLSearchParams();
        if (next) params.set("supplierId", next);
        setSearchParams(params, { replace: true });
      }}
      onSupplierClick={(id) => navigate(`/suppliers/${id}`)}
      onCreditNoteClick={(id) => navigate(`/supplier-credit-notes/${id}`)}
    />
  );
}
